<template>
  <div class="media">
    <audio controls :src="media_src"></audio>
  </div>
</template>

<script>
export default {
  name: 'AudioViewer',
  props: {
    media_src: String
  }
}
</script>

<style scoped lang="scss"></style>
